//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
let d=[[[1,"Addendum",0,"ScCollector",0],[0,"Associative",1,0],[1,"BendAllowance",0,"Expression",0],[1,"ConstraintCurveFromTargetRegion",0,"Section",0],[1,"ConstraintCurveFromUnformRegion",0,"Section",0],[0,"ContactPointsTolerance",1,0],[0,"DistanceTolerance",1,0],[0,"DrawDirection",1,"Direction",0],[1,"Faces",0,"ScCollector",0],[1,"FormingBoundary",0,"ScCollector",0],[0,"InferElementSize",1,0],[0,"InferThickness",1,0],[0,"LimitPoint1",1,"Point",0],[0,"LimitPoint2",1,"Point",0],[0,"Limits",0,"Die.DieLimitsBuilder",0],[0,"MaterialPropertyDensity",1,0],[0,"MaterialPropertyE",1,0],[0,"MaterialPropertyF",1,0],[0,"MaterialPropertyInitialStrain",1,0],[0,"MaterialPropertyK",1,0],[0,"MaterialPropertyN",1,0],[0,"MaterialPropertyPoisson",1,0],[0,"MaterialPropertyR0",1,0],[0,"MaterialPropertyR45",1,0],[0,"MaterialPropertyR90",1,0],[0,"MaterialPropertyYieldStress",1,0],[0,"MaterialType",1,0],[0,"MeshAttemptMapping",1,0],[0,"MeshElementSize",1,0],[0,"MeshElementType",1,0],[0,"MeshMaxJacobian",1,0],[0,"MeshMaxWarp",1,0],[0,"MeshProcessFillet",1,0],[0,"MeshSizeVariation",1,0],[0,"MeshSmallFeature",1,0],[0,"MeshSplitQuad",1,0],[0,"OutputMethod",1,0],[0,"RegionPoint",1,"Point",0],[0,"RemoveLoops",1,0],[0,"ReverseSide",1,0],[0,"SampleDensityIndex",1,0],[0,"SheetThickness",1,0],[0,"Smoothing",1,0],[0,"SolverConvergencyLevel",1,0],[0,"SolverJoinOutputCurves",1,0],[0,"SolverMaxIterationSteps",1,0],[0,"SolverSaveAnalysisResultsIntoFeature",1,0],[1,"Spine",0,"ScCollector",0],[0,"SpineRadius",1,0],[0,"SurfaceType",1,0],[1,"Thickness",0,"Expression",0],[0,"TrimlinePoint",1,"Point",0],[0,"Type",1,0]],[[[],"DefaultDraw",{},0,0],[[],"CreateDefaultSpine",{},0,0],[[],"Mesh",{},0,0],[[],"Calculation",{},0,0]],[]];
SPLM.Die.TrimLineDevelopmentBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.TrimLineDevelopmentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Die.TrimLineDevelopmentBuilder.OutputMethodName = Object.freeze({
    "Geometric" : "Geometric", "Corrected" : "Corrected", "Both" : "Both"});

SPLM.Die.TrimLineDevelopmentBuilder.SmoothingName = Object.freeze({
    "Linear" : "Linear", "Cubic" : "Cubic", "Quintic" : "Quintic"});

SPLM.Die.TrimLineDevelopmentBuilder.MaterialTypeName = Object.freeze({
    "Steel" : "Steel", "Aluminum" : "Aluminum"});

SPLM.Die.TrimLineDevelopmentBuilder.MeshElement = Object.freeze({
    "Triangle" : "Triangle", "Quadrate" : "Quadrate"});

SPLM.Die.TrimLineDevelopmentBuilder.Convergency = Object.freeze({
    "Low" : "Low", "Medium" : "Medium", "High" : "High"});

SPLM.Die.TrimLineDevelopmentBuilder.Surface = Object.freeze({
    "Inner" : "Inner", "Middle" : "Middle", "Outer" : "Outer"});

SPLM.Die.TrimLineDevelopmentBuilder.CalculateType = Object.freeze({
    "GeometryMethod" : "GeometryMethod", "OneStepTrimLine" : "OneStepTrimLine"});

export default SPLM;